import { useEffect, useState, useRef } from "react";

const ReadyAtBadge = ({ readyAt }) => {
    const [seconds, setSeconds] = useState(0);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (!readyAt) return;

        const ts = parseInt(readyAt) * 1000;
        if (isNaN(ts)) return;

        const compute = () => {
            const elapsed = Math.floor((Date.now() - ts) / 1000);
            setSeconds(elapsed);
        };

        compute();
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(compute, 1000);

        return () => clearInterval(intervalRef.current);
    }, [readyAt]);

    if (!readyAt) return null;

    const isOverdue = seconds > 0;
    const abs = Math.abs(seconds);
    const m = Math.floor(abs / 60);
    const s = abs % 60;

    const display = `${m}m ${String(s).padStart(2, '0')}s`;

    return (
        <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '3px 8px', borderRadius: 6, width: 'fit-content',
            background: isOverdue ? '#fef2f2' : '#f0fdf4',
            border: `1px solid ${isOverdue ? '#fecaca' : '#bbf7d0'}`,
            fontSize: 12,
            color: isOverdue ? '#dc2626' : '#15803d',
            fontWeight: 600, marginTop: 4,
        }}>
            <span style={{
                width: 6, height: 6, borderRadius: '50%',
                background: isOverdue ? '#ef4444' : '#22c55e',
                flexShrink: 0,
            }}/>
            {isOverdue ? 'Delay by' : 'Ready in'} &nbsp;
            <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                {display}
            </span>
        </div>
    );
};

export default ReadyAtBadge;